import React from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'
import { makeImgResizerUrl } from '@jelly/utils'

const Bio = styled.div`
	padding: 0.25rem 0;

	a {
		color: ${({ theme }) => theme.colors.contentLink};
	}
`
const InfoContainer = styled.div`
	margin: 1rem 0 4rem 0;
	padding-left: 0;
	width: 100%;
	${({ theme }) => theme.MQ.S} {
		margin: 1rem 0 6rem 0;
	}
	${({ theme }) => theme.MQ.M} {
		border-left: 1px solid #e4e4e4;
		margin: 1rem 0 6rem 0;
		padding-left: 2rem;
		width: 70%;
	}
`
export const Name = styled.div`
	color: #003b5c;
	font-size: 20px;
	margin: 0px;
`
const Title = styled.div`
	color: #787878;
	font-size: 1.25rem;
	line-height: 1.25;
	margin-bottom: 1rem;
	text-align: center;
	vertical-align: middle;

	${({ theme }) => theme.MQ.M} {
		text-align: left;
	}
`
const ProfileContainer = styled.div`
	display: block;

	&:first-of-type {
		/* add extra space between CEO card and title */
		margin-top: 3rem;
	}

	${({ theme }) => theme.MQ.M} {
		display: flex;
		flex-direction: row;
	}
`
const ImageContainer = styled.div`
	margin: 0 auto;
	width: 30%;
	${({ theme }) => theme.MQ.M} {
		padding-right: 2rem;
		margin: 1.2rem 0;
		width: 20%;
	}
`
const ProfileImage = styled.img`
	border-radius: 50%;
	box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.2);
	width: 100%;
	aspect-ratio: 1;
	object-fit: cover;
`

function ProfileCard({ bio, image, name, title }) {
	return (
		<ProfileContainer>
			<ImageContainer>
				<ProfileImage
					alt={`headshot of ${name}`}
					className="lazyload"
					data-src={makeImgResizerUrl({ src: image, method: 'r', w: 300, h: 300 })}
				/>
			</ImageContainer>

			<InfoContainer>
				<Title>
					<Name> {name} </Name>
					{title}
				</Title>
				<Bio dangerouslySetInnerHTML={{ __html: bio }} />
			</InfoContainer>
		</ProfileContainer>
	)
}

ProfileCard.propTypes = {
	bio: string,
	image: string,
	name: string,
	title: string,
}

export default ProfileCard
